import * as React from 'react';
import { useRestApi } from 'hooks/useRestApi';
import { apiUrl } from 'utils/apiUrl';
import { InventoryByTenant } from './types';

export function useTenantInventory(tenantId: string | undefined) {
  const [tick, setTick] = React.useState(0);
  const url = React.useMemo(() => {
    if (!tenantId) return '';
    const base = apiUrl('lct', `tenants/${tenantId}/inventory`);
    return tick > 0 ? `${base}?_t=${tick}` : base;
  }, [tenantId, tick]);

  const { data, loading, error } = useRestApi<InventoryByTenant>(url, {
    manual: !tenantId,
  });

  const refresh = React.useCallback(() => {
    if (!tenantId) return;
    setTick((n) => n + 1);
  }, [tenantId]);

  return { data, loading, error, refresh };
}

export default useTenantInventory;
